module.exports = __webpack_public_path__ + "static/process_exporting6_1-a7759d6a36d2f65df88379b4014f506c.jpg";